import { render, staticRenderFns } from "./RatingDepartmentIndex.vue?vue&type=template&id=15eef5da"
import script from "./RatingDepartmentIndex.vue?vue&type=script&lang=js"
export * from "./RatingDepartmentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports